import { computed } from 'vue'
import { useAppStore } from '@/stores/app.store'
import { useBreakpoints } from './useBreakpoints'

export function useSidebar() {
  const appStore = useAppStore()
  const { isMobile } = useBreakpoints()

  const isExpanded = computed(() => appStore.sidebarExpanded)
  const isMobileOpen = computed(() => appStore.sidebarMobileOpen)

  function toggle() {
    if (isMobile.value) {
      if (appStore.sidebarMobileOpen) {
        appStore.closeMobileSidebar()
      } else {
        appStore.openMobileSidebar()
      }
    } else {
      appStore.toggleSidebar()
    }
  }

  function close() {
    if (isMobile.value) {
      appStore.closeMobileSidebar()
    }
  }

  return {
    isExpanded,
    isMobile,
    isMobileOpen,
    toggle,
    close,
  }
}
